import ReactDOM from 'react-dom';
import App  from './App';
import './styles/style.css' ;
import './styles/image-gallery.css' ;
import './styles/style-carrusel.css' ;

ReactDOM.render(<App/>, document.getElementById('root'));


